
import React, { useState, useEffect } from "react";
import { RiDeleteBin5Line } from "react-icons/ri";
import { BiSolidEdit } from "react-icons/bi";
import { Circles } from 'react-loader-spinner';
import { FadeLoader } from 'react-spinners';


import { useLocation, Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { BaseUrl } from "../App";
// Import the Toggle component
const Toggle = ({ label, isOn, onToggle }) => (
  <div className="flex items-center justify-between">
    <span className="text-gray-700 text-sm">{label}</span>
    <label className="relative inline-flex items-center cursor-pointer">
      <input
        type="checkbox"
        value=""
        className="sr-only peer"
        checked={isOn}
        onChange={onToggle}
      />
      <div className="group peer bg-white rounded-full duration-300 w-12 h-6 ring-2 ring-red-500 after:duration-300 after:bg-red-500 peer-checked:after:bg-green-500 peer-checked:ring-green-500 after:rounded-full after:absolute after:h-4 after:w-4 after:top-1 after:left-1 peer-checked:after:translate-x-6 peer-hover:after:scale-95"></div>
    </label>
  </div>
);

const Unit = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const serviceId = location.state?.serviceId;
  console.log(location.state);
  // Extract data passed via state
  const serviceName = location.state?.method_title || "Unknown Service";
  const pricing = location.state?.serviceId || "Unknown Pricing";
  const { methods_id } = location.state || {};
  const [dropdownId, setDropdownId] = useState(null);
  const [isSliderOpen, setIsSliderOpen] = useState(false);
  const [isFrontViewOpen, setIsFrontViewOpen] = useState(false);
  const [units, setUnits] = useState([]);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [deleteServiceId, setDeleteServiceId] = useState(null);
  const [newUnit, setNewUnit] = useState({ unitName: "", basePrice: "" });
  const [selectedView, setSelectedView] = useState(null);
  const [editableUnit, setEditableUnit] = useState(null); // State for editable unit
  const [successMessage, setSuccessMessage] = useState("")
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [designImages, setDesignImages] = useState({
    design1: null,
    design2: null,
    design3: null,
  });
  useEffect(() => {
    let timer;
    if (error) {
      timer = setTimeout(() => {
        setError("");
      }, 5000); // 5 seconds
    }
    return () => clearTimeout(timer);
  }, [error]);
  useEffect(() => {
    if (!serviceId || !methods_id) {
      console.error("Service ID or Methods ID missing");
      return;
    }
    const fetchUnits = async () => {
      setLoading(true);
      try {
        const response = await axios.post(
          `${BaseUrl}/backend/api/service_units.php`,
          {
            action: "get_units_of_selected_method",
            service_id: serviceId,
            methods_id: methods_id, // Use methods_id passed from state
            api_key: "1", // Replace with your actual API key
          }
        );

        console.log("API Response: ", response.data.status);
        if (response.data.status === "true") {
          setUnits(response.data.response); // Assuming the response contains the list of units
        } else {
          console.error("Error: No units available");
        }
      } catch (error) {
        console.error("Error fetching units:", error);
      }
      finally {
        setLoading(false);
      }
    };

    fetchUnits();
  }, [serviceId, methods_id]); // Ensure useEffect runs when either serviceId or methods_id changes

  // Arrays for dropdown options
  const hoursOptions = [1, 2, 3, 4, 5]; // Example hours options
  const minutesOptions = [0, 15, 30, 45]; // Example minutes options
  const unitSymbolOptions = ["sq. ft.", "m²", "km²"]; // Example unit symbols

  const handleAddUnit = async () => {
    setLoading(true);
    if (!newUnit.unitName || !newUnit.basePrice) {
      alert("Please provide both Unit Name and Base Price");
      setLoading(false);
      return;
    }
  
    try {
      const response = await axios.post(
        `${BaseUrl}/backend/api/service_units.php`,
        {
          action: "add_services_method_unit",
          api_key: "1",
          services_id: serviceId,
          methods_id: methods_id,
          units_title: newUnit.unitName,
          base_price: newUnit.basePrice,
          minlimit: 0,
          maxlimit: 10,
          status: "active",
          unit_symbol: "",
          half_section: "",
        }
      );
  
      console.log("API Response: ", response.data);
  
      if (response.data.status === "true") {
        setSuccessMessage("Added Service Method Unit Successfully!");
        
        // Use the actual data returned from the API to update the state
        const addedUnit = {
          // id: response.data.response.unit_id || Date.now(), // Use the real unit_id from the API if available
          units_title: newUnit.unitName,
          base_price: newUnit.basePrice,
          minlimit: 0,
          maxlimit: 10,
          status: "E", // Assuming "E" means enabled/active
          enabled: true, // For the toggle component
        };
  
        // Update the units state with the new unit
        setUnits((prevUnits) => [...prevUnits, addedUnit]);
        
        // Reset the form and close the slider
        setNewUnit({ unitName: "", basePrice: "" });
        setIsSliderOpen(false);
      } else {
        alert("Failed to add unit.");
      }
    } catch (error) {
      console.error("Error adding unit:", error);
      // alert("Error adding unit");
    } finally {
      setLoading(false);
    }
  };
  const toggleUnit = (id) => {
    setUnits(
      units.map((unit) =>
        unit.id === id ? { ...unit, enabled: !unit.enabled } : unit
      )
    );
  };

  const deleteUnit = async () => {
    setLoading(true);
    if (!deleteServiceId) return;

    try {
      const response = await axios.post(
        `${BaseUrl}/backend/api/service_units.php`,
        {
          action: "delete_services_method_unit",
          api_key: "1", // Your API key
          unit_id: deleteServiceId,
        }
      );

      if (response.data.status === "true") {
        setSuccessMessage("Unit deleted successfully!")
        setUnits(units.filter((unit) => unit.id !== deleteServiceId)); // Remove from state
        setDeleteServiceId(null);
        setIsDeleteModalVisible(false);
        console.log("delete unit successfully deleted", response.data);
        alert("Unit deleted successfully");
      } else {
        alert("Failed to delete unit.");
      }
    } catch (error) {
      console.error("Error deleting unit:", error);
      alert("Error deleting unit.");
    }
    finally {
      setLoading(false);
    }
  };

  const toggleDropdown = (id) => {
    setDropdownId(dropdownId === id ? null : id); // Toggle dropdown for the specific unit

    // Find the unit to edit
    const unitToEdit = units.find((unit) => unit.id === id); // Find the unit to edit
    console.log(unitToEdit);

    if (unitToEdit) {
      setEditableUnit({
        ...unitToEdit, // Spread the data from the selected unit to editableUnit
        units_title: unitToEdit.units_title, // Ensure the unit's title is set correctly
        base_price: unitToEdit.base_price,
        minlimit: unitToEdit.minlimit,
        maxlimit: unitToEdit.maxlimit,
        unit_symbol: unitToEdit.unit_symbol,
        enabled: unitToEdit.enabled, // If enabled is needed, set it as well
      });
    }
  };

  const handleStatusChange = async (unitId, currentStatus) => {
    setLoading(true);
    const newStatus = currentStatus === "E" ? "D" : "E"; // Toggle status between 'E' and 'D'
    try {
      const response = await axios.post(
        `${BaseUrl}/backend/api/service_units.php`,
        {
          action: "change_status_of_services_method_unit",
          api_key: "1", // Replace with your actual API key
          unit_id: unitId,
          status: newStatus,
        }
      );
      if (response.data.status === "true") {
        setSuccessMessage("Unit status changed successfully");
        // Update the unit's status in the local state
        setUnits((prevUnits) =>
          prevUnits.map((unit) =>
            unit.id === unitId ? { ...unit, status: newStatus } : unit
          )
        );
        alert(
          `Unit status changed to ${newStatus === "E" ? "Enabled" : "Disabled"}`
        );
      } else {
        alert("Failed to change unit status");
      }
    } catch (error) {
      console.error("Error changing status:", error);
      alert("Error changing status");
    }
    finally {
      setLoading(false);
    }
  };
  const handleUpdateUnit = async () => {
    setLoading(true);
    try {
      if (!editableUnit) {
        alert("No unit selected for update");
        console.log(editableUnit);
        return;
      }

      // Ensure that all necessary fields are set properly
      const {
        id,
        units_title,
        base_price,
        minlimit,
        maxlimit,
        status,
        position,
        limit_title,
        unit_symbol,
        half_section,
        uduration,
      } = editableUnit;

      // Send the update request to the backend
      const response = await axios.post(
        `${BaseUrl}/backend/api/service_units.php`,
        {
          action: "update_services_method_unit",
          api_key: "1", // Replace with your actual API key
          unit_id: id, // Use the unit ID
          services_id: serviceId, // Assuming serviceId is available in the component
          methods_id: methods_id, // Assuming methods_id is available in the component
          units_title: units_title,
          base_price: base_price,
          minlimit: minlimit,
          maxlimit: maxlimit,
          status: status ? "D" : "E", // Adjust based on status (assuming status is a boolean)
          position: position,
          limit_title: limit_title,
          unit_symbol: unit_symbol,
          half_section: half_section || "D", // Default to 'D' if half_section is undefined
          uduration,
        }
      );
      console.log("API Response:", response.data);
      if (response.data.status === "true") {
        setSuccessMessage("Update Service Method Unit Successfully!")
        // Update the unit list with the new data
        setUnits((prevUnits) =>
          prevUnits.map((unit) =>
            unit.id === editableUnit.id
              ? { ...unit, ...editableUnit } // Ensure this includes the updated values
              : unit
          )
        );
        setDropdownId(null); // Close the dropdown
        alert("Unit updated successfully!");
      } else {
        alert("Failed to update unit");
      }
    } catch (error) {
      console.error("Error updating unit:", error);
      alert("Error updating unit");
    }
     finally {
      setLoading(false);
    }
  };
  const fetchDesign = async (viewType) => {
    if (!serviceId || !methods_id) {
      console.error("Service ID or Methods ID missing");
      return;
    }
    let designApiUrl = "";
    switch (viewType) {
      case "design1":
        designApiUrl =
          "http://10.27.1.112:80/megaclean/backend/assets/images/democheck/service-unit-design-1.jpg";
        break;
      case "design2":
        designApiUrl =
          "http://10.27.1.112:80/megaclean/backend/assets/images/democheck/service-unit-design-2.jpg";
        break;
      case "design3":
        designApiUrl =
          "http://10.27.1.112:80/megaclean/backend/assets/images/democheck/service-unit-design-3.jpg";
        break;
      default:
        return;
    }

    try {
      const response = await axios.post(designApiUrl, { responseType: "blob" }); // Using GET and responseType: 'blob'
      const imageUrl = URL.createObjectURL(response.data); // Create a blob URL from the image data
      setDesignImages((prev) => ({
        ...prev,
        [viewType]: imageUrl, // Store the blob URL in state for rendering
      }));
    } catch (error) {
      console.error("Error fetching design:", error);
    }
  };
  const handleRadioButtonChange = async (viewType) => {
    console.log(viewType);
    setSelectedView(viewType); // Update the selected view
    let id;
    let serviceMethodId;  // This will hold the dynamic value of service_method_id
    // Directly assign the dynamic value based on the current condition
    switch (viewType) {
      case "design1":
        id = 2; // Design ID for design1
        serviceMethodId = methods_id;  // Directly use the dynamic value from methods_id (no state change)
        break;
      case "design2":
        id = 3; // Design ID for design2
        serviceMethodId = methods_id;  // Directly use the dynamic value from methods_id (no state change)
        break;
      case "design3":
        id = 4; // Design ID for design3
        serviceMethodId = methods_id;  // Directly use the dynamic value from methods_id (no state change)
        break;
      case "design4":
        id = 5; // Design ID for design4
        serviceMethodId = methods_id;  // Directly use the dynamic value from methods_id (no state change)
        break;
      default:
        return;
    }
  
    const formData = new FormData();
    formData.append("designid", id); // Pass the dynamic design id
    formData.append("service_method_id", serviceMethodId);  // Pass the dynamic service_method_id (from methods_id)
    formData.append("assigndesign", 1); // Static value for assigndesign (or dynamic if needed)
  
    try {
      // Send the POST request with formData
      const result = await axios.post(
        "http://10.27.1.112:80/cleanto/assets/lib/service_method_units_ajax.php",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data", // Ensure the request is sent as form-data
          },
        }
      );
      console.log("API Response:", result.data); // Handle API response
    } catch (error) {
      console.error("Error during the API call", error); // Handle errors
    }
  
    // Optionally, you can fetch the design after the radio button change
    fetchDesign(viewType);
  };

  return (
    <div className="relative min-h-screen">
    {/* Loading Indicator */}
      {loading && (
           <div className="fixed inset-0 flex items-center justify-center z-50">
             <div className="flex flex-col items-center p-3 bg-black border border-white rounded-2xl">
               <FadeLoader 
                 height={15}
                 width={5}
                 color="#ffffff"
                 ariaLabel="loading"
               />
               <h1 className="mt-1 text-lg text-white">Please wait...</h1>
             </div>
           </div>
         )}
         
        <div className="container mx-auto px-4 py-6">
                  {successMessage && (
            <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative mb-4">
              <span className="block sm:inline">{successMessage}</span>
            </div>
          )}

          {error && (
            <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4">
              <span className="block sm:inline">{error}</span>
            </div>
          )}

          {/* Display navigation trail */}
          <div className="mb-4">
            <Link to="/admin/service" className="text-blue-500 hover:underline">
              Services
            </Link>
            <span className="mx-2">→</span>
            <span
              className="text-blue-500 hover:underline cursor-pointer"
              onClick={() =>
                navigate("/admin/service/pricing", {
                  state: { serviceId, serviceName, }, // Pass the serviceName back to Pricing
                })
              }
            >
              {pricing}
            </span>
            <span className="mx-2">→</span>
            <span className="text-gray-700">Add Unit</span>
          </div>

          {/* Buttons */}
          <div className="flex justify-end space-x-4">
            <button
              className="px-4 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-600 transition"
              onClick={() => setIsFrontViewOpen(true)}
            >
              Front View Option
            </button>
            <button
              className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition"
              onClick={() => setIsSliderOpen(true)}
            >
              + Add Unit
            </button>
          </div>

          {/* Front View Pop-up */}
          {isFrontViewOpen && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
              <div className="bg-white p-6 rounded-md w-3/4 max-w-4xl">
                <div className="flex justify-between items-center">
                  <h2 className="text-xl font-bold mb-4">
                    Method Units Front View
                  </h2>
                  <button
                    className="text-gray-500 hover:text-red-500"
                    onClick={() => setIsFrontViewOpen(false)}
                  >
                    ✖
                  </button>
                </div>
                <div className="space-y-6">
                  {/* Front View Radio Buttons */}
                  <div>
                    <label className="font-medium flex items-center">
                      <input
                        type="radio"
                        name="frontView"
                        className="mr-2"
                        checked={selectedView === "design1"}
                        onChange={() => handleRadioButtonChange("design1")}
                      />
                      Service Unit Front DropDown View
                    </label>
                    <img
                      src={`http://10.27.1.112:80/megaclean/backend/assets/images/democheck/service-unit-design-1.jpg`}
                      alt="Design 1"
                      className="w-full h-auto mt-4"
                    />
                    {selectedView === "design1" &&
                      designImages.design1 &&
                      console.log("Helllllllllllllllllllllllllllllllllllo")}
                  </div>

                  <div>
                    <label className="font-medium flex items-center">
                      <input
                        type="radio"
                        name="frontView"
                        className="mr-2"
                        checked={selectedView === "design2"}
                        onChange={() => handleRadioButtonChange("design2")}
                      />
                      Service Unit Front Block View
                    </label>
                    <img
                      src={`http://10.27.1.112:80/megaclean/backend/assets/images/democheck/service-unit-design-2.jpg`}
                      alt="Design 2"
                      className="w-full h-auto mt-4"
                    />
                    {selectedView === "design2" &&
                      designImages.design2 &&
                      console.log("Hellllllllllllllllllllllllllllllo 2")}
                  </div>

                  <div>
                    <label className="font-medium flex items-center">
                      <input
                        type="radio"
                        name="frontView"
                        className="mr-2"
                        checked={selectedView === "design3"}
                        onChange={() => handleRadioButtonChange("design3")}
                      />
                      Service Unit Front Increase/Decrease View
                    </label>
                    <img
                      src={`http://10.27.1.112:80/megaclean/backend/assets/images/democheck/service-unit-design-3.jpg`}
                      alt="Design 3"
                      className="w-full h-auto mt-4"
                    />
                    {selectedView === "design3" &&
                      designImages.design3 &&
                      console.log("Hellllllllllllllllllllllllllllo 3")}
                  </div>

                  {/* Square Meter View */}
                  <div>
                    <label className="font-medium flex items-center">
                      <input
                        type="radio"
                        name="frontView"
                        className="mr-2"
                        onChange={() => handleRadioButtonChange("design4")}
                      />
                      Service Unit Front Square Meter View
                    </label>
                  </div>
                </div>

                <div className="mt-6 text-right">
                  <button
                    className="px-4 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-600 transition"
                    onClick={() => setIsFrontViewOpen(false)}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Slider */}
          {isSliderOpen && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex z-50 justify-end">
              <div className="relative w-full sm:w-2/3 md:w-1/2 lg:w-1/3 h-full bg-white shadow-lg p-6  overflow-auto">
                <div className="flex justify-between items-center">
                  <h2 className="text-xl font-bold">Add Unit</h2>
                  <button
                    className="text-gray-500 hover:text-red-500"
                    onClick={() => setIsSliderOpen(false)}
                  >
                    ✖
                  </button>
                </div>
                <div className="mt-4">
                  <label className="block mb-2 font-medium">Unit Name</label>
                  <input
                    type="text"
                    value={newUnit.units_title}
                    onChange={(e) =>
                      setNewUnit({ ...newUnit, unitName: e.target.value })
                    }
                    className="w-full px-4 py-2 border rounded-md"
                  />
                </div>
                <div className="mt-4">
                  <label className="block mb-2 font-medium">Base Price</label>
                  <input
                    type="number"
                    value={newUnit.base_price}
                    onChange={(e) =>
                      setNewUnit({ ...newUnit, basePrice: e.target.value })
                    }
                    className="w-full px-4 py-2 border rounded-md"
                  />
                </div>
                <button
                  onClick={handleAddUnit}
                  className="mt-6 w-full bg-blue-500 text-white py-2 rounded-md hover:bg-blue-600 transition"
                >
                  Save
                </button>
              </div>
            </div>
          )}

          {/* Unit Cards */}
          <div className="mt-6">
            {units.map((unit) => (
              <div
                key={unit.id}
                className="flex flex-col border p-4 rounded-md mb-4 shadow"
              >
                <div className="flex justify-between items-center">
                  <div>
                    <p className="text-lg font-bold">{unit.units_title}</p>
                    <p className="text-gray-600">
                      Base Price: ${unit.base_price}
                    </p>
                  </div>
                  <div className="flex items-center space-x-4">
                    <Toggle
                      label={unit.status === "E" ? "" : ""}
                      isOn={unit.status === "E"}
                      onToggle={() => handleStatusChange(unit.id, unit.status)}
                    />
                    <RiDeleteBin5Line
                      onClick={() => {
                        setDeleteServiceId(unit.id);
                        setIsDeleteModalVisible(true);
                      }}
                      className="cursor-pointer w-8 h-8 text-red-500"
                    />
                    <BiSolidEdit
                      onClick={() => toggleDropdown(unit.id)}
                      className="cursor-pointer w-8 h-8 text-blue-500"
                    />
                  </div>
                </div>

                {/* Dropdown for editing unit */}
                {dropdownId === unit.id && (
                  <div className="mt-4">
                    <div>
                      <label className="block mb-2 font-medium">
                        Unit Name
                      </label>
                      <input
                        type="text"
                        value={editableUnit?.units_title || ""}
                        onChange={(e) =>
                          setEditableUnit({
                            ...editableUnit,
                            units_title: e.target.value,
                          })
                        }
                        className="w-full px-4 py-2 border rounded-md"
                      />
                    </div>

                    <div>
                      <label className="block mt-4 mb-2 font-medium">
                        Base Price
                      </label>
                      <input
                        type="number"
                        value={editableUnit?.base_price || ""}
                        onChange={(e) =>
                          setEditableUnit({
                            ...editableUnit,
                            base_price: e.target.value,
                          })
                        }
                        className="w-full px-4 py-2 border rounded-md"
                      />
                    </div>

                    {/* Duration and Unit Symbol */}
                    <label className="block mb-2 mt-4 font-medium">
                      Duration
                    </label>
                    <div className="flex space-x-2 mt-4">
                      <select
                        value={editableUnit?.hours}
                        onChange={(e) =>
                          setEditableUnit({
                            ...editableUnit,
                            uduration: e.target.value,
                          })
                        }
                        className="w-1/2 px-4 py-2 border rounded-md"
                      >
                        {hoursOptions.map((hour, index) => (
                          <option key={index} value={hour}>
                            {hour} Hour
                          </option>
                        ))}
                      </select>
                      <select
                        value={editableUnit?.minutes}
                        onChange={(e) =>
                          setEditableUnit({
                            ...editableUnit,
                            minutes: e.target.value,
                          })
                        }
                        className="w-1/2 px-4 py-2 border rounded-md"
                      >
                        {minutesOptions.map((minute, index) => (
                          <option key={index} value={minute}>
                            {minute} Minutes
                          </option>
                        ))}
                      </select>
                    </div>
                    <label className="block mt-4 mb-2 font-medium">
                      Min/Max Limit
                    </label>

                    <div className="flex space-x-2 mt-4">
                      <input
                        type="number"
                        value={editableUnit?.minlimit}
                        onChange={(e) =>
                          setEditableUnit({
                            ...editableUnit,
                            minlimit: e.target.value,
                          })
                        }
                        className="w-1/2 px-4 py-2 border rounded-md"
                        placeholder="Min"
                      />
                      <input
                        type="number"
                        value={editableUnit?.maxlimit}
                        onChange={(e) =>
                          setEditableUnit({
                            ...editableUnit,
                            maxlimit: e.target.value,
                          })
                        }
                        className="w-1/2 px-4 py-2 border rounded-md"
                        placeholder="Max"
                      />
                    </div>
                    {/* Unit Label Field */}
                    <div className="mt-4">
                      <label className="block mb-2 font-medium">Label</label>
                      <input
                        type="text"
                        value={editableUnit?.limit_title}
                        onChange={(e) =>
                          setEditableUnit({
                            ...editableUnit,
                            limit_title: e.target.value,
                          })
                        }
                        className="w-full px-4 py-2 border rounded-md"
                      />
                    </div>
                    {/* Unit Symbol Field */}
                    <div className="mt-4">
                      <label className="block mb-2 font-medium">
                        Unit Symbol
                      </label>
                      <select
                        value={editableUnit?.unit_symbol}
                        onChange={(e) =>
                          setEditableUnit({
                            ...editableUnit,
                            unit_symbol: e.target.value,
                          })
                        }
                        className="w-full px-4 py-2 border rounded-md"
                      >
                        {unitSymbolOptions.map((symbol, index) => (
                          <option key={index} value={symbol}>
                            {symbol}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="mt-4 text-right">
                      <button
                        onClick={handleUpdateUnit}
                        className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
                      >
                        Save Changes
                      </button>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
          {isDeleteModalVisible && (
            <div className="fixed inset-0 z-50 bg-gray-800 bg-opacity-75 flex items-center justify-center">
              <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
                <h2 className="text-lg font-medium mb-4">Confirm Delete</h2>
                <p>Are you sure you want to delete this Unit?</p>
                <div className="flex justify-end space-x-2 mt-4">
                  <button
                    onClick={() => setIsDeleteModalVisible(false)}
                    className="px-4 py-2 bg-gray-500 text-white rounded-md"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={deleteUnit}
                    className="px-4 py-2 bg-red-500 text-white rounded-md"
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
     
    </div>
  );
};

export default Unit;

